<nz-layout class="height-full">
    <nz-header class="am-dash-navbar" [ngClass]="{ 'dev-mode': isDevMode }">
        <div class="navbar-row">
            <app-navbar></app-navbar>
            <span class="navbar-spacer"></span>
            <app-data-project-switcher></app-data-project-switcher>
        </div>
    </nz-header>
    <div class="height-full min-height-0">
        <router-outlet></router-outlet>
    </div>
</nz-layout>

<div class="extras">
    <app-version></app-version>
    <ng-container *ngIf="isSignedIn">
        <a class="extra" [routerLink]="['jobs', 'summary']" [queryParams]="linkQueryParams()">Jobs</a>
        <a class="extra" (click)="signOut()">Logout</a>
    </ng-container>
</div>
